import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class RequestRoleGuard implements CanActivate {
  constructor(private router: Router, private userService: UserService) {}

  canActivate(): Observable<boolean> {
    return this.userService.getCurrentLoggedInUserDetails().pipe(
      map(data => {
        if (data?.userRole === 'Engagement User') {
          this.router.navigate(['/no-access']);
          return false;
        }
        return true;
      })
    );
  }
}